import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyC_Fp0oJs5cizSueYhcbKsw8WpKcxM4yOY",
  authDomain: "sendvigo.firebaseapp.com",
  projectId: "sendvigo",
  storageBucket: "sendvigo.firebasestorage.app",
  messagingSenderId: "667848334773",
  appId: "1:667848334773:web:d07f45d747d5d55b1bcdfc"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const token = await getToken(messaging, {
        vapidKey: 'BC31_xkEB1fqnCfFLbXwsyC0jHoakCabgURdbb1WEUjyKI-SNFSTGaFuqaHfrbK7LuWdK8S2GXR6p64tr8bug3I'
      });
      return token;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => resolve(payload));
  });